import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-options-section',
  templateUrl: './access-options-section.component.html',
  styleUrls: ['./access-options-section.component.scss']
})
export class AccessOptionsSectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
